// extracted by mini-css-extract-plugin
module.exports = {"removeButton":"screenList_removeButton__2E5py","container":"screenList_container__3vPe1"};